import { Injectable } from '@angular/core';

@Injectable()
export class MarkdownConfig {
  /** config modue */

}



// WEBPACK FOOTER //
// ./src/markdown/markdown.config.ts